"use client"
import { Component } from "@/types"
import { cx } from "@/utils/cx"
import { MarketingNav } from "../../_sections/MarketingNav/MarketingNav"
import { HeroSection } from "./_sections/HeroSection"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { MagicCircle } from "@/ui/atoms/flourishes/MagicCircle"
import { CyberSecuritySection } from "./_sections/CyberSecuritySection"
import { CourseOverview } from "./_sections/CourseOverview"
import { CourseFeatures } from "./_sections/CourseFeatures"
import { CourseSyllabus } from "./_sections/CourseSyllabus"
import { Testimonials } from "./_sections/Testimonials"
import { CtaSection } from "./_sections/CtaSection"
import { TrackPageView } from "@/ui/utils/TrackPageView"
import { tx } from "@/utils/tx"

export const COMPONENT_NAME = "home"

export const presets = {}

export interface Props extends Component {}

export function HomeView({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <>
      <TrackPageView pageName="Home page" />
      <div className={cx(``, className)} data-test={testId}>
        <div className="bg-gray-800 overflow-hidden theme-dark">
          <MarketingSection removeYPadding className="">
            <div className="relative">
              <MagicCircle
                className={cx(
                  "absolute",
                  "top-0 right-1/2 -translate-y-1/2 translate-x-1/2",
                  "md:top-0 md:right-0 md:-translate-y-1/2 md:translate-x-2/3",
                )}
              />
              <MarketingNav
                useDarkTheme
                className="relative z-1"
                testId={tx(testId, "global-nav")}
              />
              <HeroSection className="relative" />
            </div>
          </MarketingSection>
        </div>
        <CyberSecuritySection />
        <CourseOverview className="bg-gray-150" />
        <CourseFeatures />

        <div className="grid grid-single-cell overflow-hidden bg-gray-150 ">
          <MarketingSection className="relative" removeYPadding>
            <MagicCircle
              className={cx(
                "hidden md:block",
                "absolute",
                "bottom-0 left-0 translate-y-1/2 -translate-x-1/2",
                "md:-translate-x-2/3",
              )}
            />
          </MarketingSection>
          <CourseSyllabus className="col-start-1 row-start-1 relative" />
        </div>

        <div className="grid grid-single-cell overflow-hidden bg-gray-800 ">
          <MarketingSection className="relative" removeYPadding>
            <MagicCircle
              className={cx(
                "hidden md:block",
                "absolute",
                "top-0 left-0 -translate-y-1/2 -translate-x-1/2",
                "md:-translate-x-2/3",
              )}
            />
          </MarketingSection>
          <Testimonials className="col-start-1 row-start-1 relative" />
        </div>
        <div className="bg-gray-800 theme-dark">
          <MarketingSection className="!pt-0 sm:!pt-0 md:!pt-0 lg:!pt-0">
            <CtaSection className="" />
          </MarketingSection>
        </div>
      </div>
    </>
  )
}
